import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';

import dataReducer from './data/reducer';
import dataSaga from './data/sagas';
import detailsReducer from './detailsPage/data/reducer';
import detailsSaga from './detailsPage/data/sagas';
import listReducer from './listPage/data/reducer';
import listSaga from './listPage/data/sagas';
import routes from './routes';

const reducer = combineReducers({
  data: dataReducer,
  detailsPage: detailsReducer,
  listPage: listReducer,
});

const saga = function* () {
  yield all([dataSaga(), detailsSaga(), listSaga()]);
};

export { reducer, saga, routes };

export * from './const';
export type * from './types';
